/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_TENANT_ARRAY_SETTINGS = gql`
  query getTenantArraySettings {
    tenantArraySettings {
      insideSalesCategories
      outsideSalesCategories
      fuelSalesCategories
    }
  }
`
